<template>
  <div
    class="product-information mt-16 lg:mt-8 mb-20"
  >
    <SkeletonLoader
      height="32px"
      width="300px"
      class="mb-6"
    />
    <SkeletonLoader
      height="150px"
      width="75%"
    />
    <div class="bg-EXPONDO-grey-5 h-px w-full my-4" />
    <SkeletonLoader
      height="32px"
      class="mb-6"
    />
    <div class="bg-EXPONDO-grey-5 h-px w-full my-4" />
    <SkeletonLoader
      height="32px"
      class="mb-6"
    />
    <div class="bg-EXPONDO-grey-5 h-px w-full my-4" />
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ProductInformationSkeleton',
});

</script>
